export default [
    {
        "id": "promotionalBanner-1",
        "plugin": "NewPromo",
        "pluginId": 1,
        "name": null,
        "html": require('./promotionalBanners/promotionalBanner-1/html').default,
        "scss": require('./promotionalBanners/promotionalBanner-1/scss').default,
        "css": require('./promotionalBanners/promotionalBanner-1/css').default,
        "cssTablet": require('./promotionalBanners/promotionalBanner-1/cssTablet').default,
        "scssTablet": require('./promotionalBanners/promotionalBanner-1/scssTablet').default,
        "cssMobile": require('./promotionalBanners/promotionalBanner-1/cssMobile').default,
        "scssMobile": require('./promotionalBanners/promotionalBanner-1/scssMobile').default,
        "js": require('./promotionalBanners/promotionalBanner-1/js').default,
        "minJs": require('./promotionalBanners/promotionalBanner-1/minJs').default,
        "settings": "",
        "svgContent": require('./promotionalBanners/promotionalBanner-1/svgContent').default,
        "svgViewBox": "0 0 1440 754",
        "svgContentMobile": require('./promotionalBanners/promotionalBanner-1/svgContentMobile').default,
        "svgViewBoxMobile": "0 0 360 787",
        "config": '{"Image": true, "TotalItems": 4, "Type": 1, "IncludeGroup": true}',
        "showOptions": true,
        "userFriendlyName": [
            "promotion",
            "new-product",
            "most-viewed",
            "top-sellers",
            "cross-seling",
            "product-from-nls",
            "rec-products",
            "product-sale",
            "product-extra-qty",
            "product-extra-pr",
            "best-rated",
            "product-slr-rcmd",
            "product-announce",
            "suggested-products",
            "reward",
            "rec-manual-select",
            "rec-categories",
            "rec-producer",
            "rec-brand",
            "rec-recently-viewed"
        ],
    },
    {
        "id": "promotionalBanner-2",
        "plugin": null,
        "pluginId": null,
        "name": null,
        "html": require('./promotionalBanners/promotionalBanner-2/html').default,
        "scss": require('./promotionalBanners/promotionalBanner-2/scss').default,
        "css": require('./promotionalBanners/promotionalBanner-2/css').default,
        "cssTablet": require('./promotionalBanners/promotionalBanner-2/cssTablet').default,
        "scssTablet": require('./promotionalBanners/promotionalBanner-2/scssTablet').default,
        "cssMobile": require('./promotionalBanners/promotionalBanner-2/cssMobile').default,
        "scssMobile": require('./promotionalBanners/promotionalBanner-2/scssMobile').default,
        "js": require('./promotionalBanners/promotionalBanner-2/js').default,
        "minJs": require('./promotionalBanners/promotionalBanner-2/minJs').default,
        "settings": "",
        "svgContent": require('./promotionalBanners/promotionalBanner-2/svgContent').default,
        "svgViewBox": "0 0 1440 450",
        "svgContentMobile": require('./promotionalBanners/promotionalBanner-2/svgContentMobile').default,
        "svgViewBoxMobile": "0 0 360 614",
        "config": '{"Image": true, "TotalItems": 4, "Type": 1, "IncludeGroup": true}',
        "showOptions": false,
    }
]